import React from "react";

const NameSmallLine = props => {
	const classNameTop = props.displayTop ? `p-clr-nm ${props.displayTop}` : "";
	const classNameBottom = props.displayBottom
		? `p-clr-nm ${props.displayBottom}`
		: "";
	return (
		<div
			style={{
				height: props.height,
				width: props.width,
				display: "flex",
				alignItems: "center",
			}}
		>
			{props.displayTop ? (
				<span
					className={classNameTop}
					style={{ fontSize: "2.5vh", marginRight: 5 }}
				/>
			) : null}
			{props.displayBottom ? (
				<span
					className={classNameBottom}
					style={{ fontSize: "2vh", marginRight: 5 }}
				/>
			) : null}
			<span>{props.name}</span>
		</div>
	);
};

export default NameSmallLine;



// WEBPACK FOOTER //
// src/modules/stats/components/GraphViews/NameSmallLine.js